import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { sumBy } from 'lodash';

export type SumByFilter = (
  value: { [s: string]: number }[],
  key: string,
) => number;

interface ISumBy {
  transform: SumByFilter;
}

/**
 * Filter that sum all entities by the provided key
 * @param {object[<key>]} array of objects with key
 * @param {string} key
 * @return {number} sum of the values
 */
@Pipe({ name: 'sumBy' })
export class SumByPipe implements PipeTransform, ISumBy {
  constructor() {
    'ngInject';
  }

  public transform(value: { [s: string]: number }[], key: string): number {
    return sumBy(value, key);
  }
}
